export const getValueFromField = (field: string, values: any) => {
  const fieldsToAccess = field.split('.')
  let value = values
  fieldsToAccess.forEach((fieldToAccess) => {
    value = value[fieldToAccess]
  })

  return value
}
